import { IconInfoCircle } from '@tabler/icons-react'

interface ContactAdminCardProps {
  title: string
  description: string
}

export function ContactAdminCard({
  title,
  description,
}: ContactAdminCardProps) {
  return (
    <div className="rounded-md bg-linear-to-br from-blue-50 to-indigo-50 p-5 shadow-sm dark:from-blue-950/30 dark:to-indigo-950/30">
      <div className="flex items-start gap-3">
        <div className="mt-0.5 shrink-0">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-100 dark:bg-blue-900/50">
            <IconInfoCircle className="h-5 w-5 text-blue-600 dark:text-blue-400" />
          </div>
        </div>
        <div className="flex-1 space-y-2">
          <h4 className="text-base font-semibold text-blue-900 dark:text-blue-100">
            {title}
          </h4>
          <p className="text-sm leading-relaxed text-blue-800/90 dark:text-blue-200/90">
            {description}
          </p>
        </div>
      </div>
    </div>
  )
}
